import React from 'react';
import image_base from '../resources/image/GrandeeHamanako2.jpg';
import GolfBookingConfirmTemplate from '../components/template/golfBookingConfirmTemplate';
import common from "../resources/js/common/common";
import { golfReservationList } from '../const';

class GolfBookingConfirm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // 予約確認モーダル
            reservationPopup: false,
            popupDataList: [],
            popupMessage: "",
            popupMode: "",
            popupTitle: "",
            // チェックイン・アウトモーダル
            calendarPopup: false,
            // チェックリストモーダル
            checkListPopup: false,
            beforeAreaId: "",
            beforeCountryId: "",
            golfReservationCancelPopup:false,
        };
    };
    render() {
        
        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            },
        }

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ golfReservationPopup: false }); };

        // キャンセルモーダルClose
        const onClickCloseCancelPopupWindow = () => {
            this.setState({ golfReservationCancelPopup: false });
        }
        // キャンセルモーダルOpen
        const onClickOpenCancelPopupWindow = () => {
            this.setState({ golfReservationCancelPopup: true });
        }
        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (loginId) => {
            this.setState({
                golfReservationPopup: true,
            });

            common.doPost(golfReservationList, { userId : loginId }, afterConfirmGolfReservation);
        }

        // 予約情報取得後処理
        const afterConfirmGolfReservation = (res) => {
            if (res.data.resultCode !== 0) {

            } else {
                this.setState(
                    {
                        popupDataList: res.data.Data,
                    }
                );
            }
        }

        return (
            <div style={style.base}>
                <GolfBookingConfirmTemplate
                    state={this.state}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    onClickCloseCancelPopupWindow={onClickCloseCancelPopupWindow}
                    onClickOpenCancelPopupWindow={onClickOpenCancelPopupWindow}
                />
            </div>
        )
    }
}
export default GolfBookingConfirm;